import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const AllPersonnel = React.lazy(() => import('.'));

export const allPersonnelRoutes = [
  new Route({
    path: 'all-personnel',
    element: AllPersonnel,
    children: [],
  }),
];
